/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { KTSVG } from '_metronic/helpers'
import { Link } from 'react-router-dom'
// import { Dropdown1 } from '_metronic/partials'
import clsx from 'clsx'
import { useAuthStore } from 'Store/Auth'
import { shallow } from 'zustand/shallow'

interface Props {
  project?: any
  pages: {
    label: string
    href: string
    active: boolean
  }[]
  isDownloadDailyReport?: boolean
  onDownloadDailyReport?: () => void
}

const ProjectDetailHeader: React.FC<Props> = ({
  project,
  pages,
  isDownloadDailyReport,
  onDownloadDailyReport,
}) => {
  const progression = ((project?.totalHammered ?? 0) / (project?.totalOrderPiles ?? 0)) * 100
  const { profile } = useAuthStore(state => ({ profile: state.profile }), shallow)
  const userRoleId = profile?.roleId || 0
  const isHideExecutePile = [2, 7, 8, 21].includes(userRoleId)

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-body pt-9 pb-0'>
        <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
          <div className='flex-grow-1'>
            <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
              <div className='d-flex flex-column'>
                <div className='d-flex align-items-center mb-2'>
                  <a href='#' className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1'>
                    {project.saleOrder?.customerTitle ?? ''}
                  </a>
                  <a href='#'>
                    <KTSVG
                      path='/media/icons/duotune/general/gen026.svg'
                      className='svg-icon-1 svg-icon-primary'
                    />
                  </a>
                </div>

                <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                  <a
                    href='#'
                    className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'>
                    <KTSVG
                      path='/media/icons/duotune/communication/com006.svg'
                      className='svg-icon-4 me-1'
                    />
                    {project.saleOrder?.saleTitle ?? '-'}
                  </a>
                  <a
                    href='#'
                    className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'>
                    <KTSVG
                      path='/media/icons/duotune/general/gen018.svg'
                      className='svg-icon-4 me-1'
                    />
                    {project.fullAddress ?? '-'}
                  </a>
                  <a
                    href='#'
                    className='d-flex align-items-center text-gray-400 text-hover-primary mb-2'>
                    <KTSVG
                      path='/media/icons/duotune/communication/com011.svg'
                      className='svg-icon-4 me-1'
                    />
                    {project.saleOrder?.customerEmail ?? '-'}
                  </a>
                </div>
              </div>

              <div className='d-flex my-4'>
                {/* <button
                  className='btn btn-sm btn-primary me-3'
                  onClick={onDownloadDailyReport}
                  disabled={isDownloadDailyReport}>
                  {isDownloadDailyReport ? 'กำลังดาวน์โหลด...' : 'ดาวน์โหลดรายงานประจำวัน'}
                </button> */}

                {!project?.shippingOnly && !isHideExecutePile && (
                  <Link
                    to={`/project/${project.id}/pile-execution`}
                    className='btn btn-success btn-primary me-3'>
                    ตอกเสาเข็ม
                  </Link>
                )}
                {/* <div className='me-0'>
                  <button
                    className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                    data-kt-menu-trigger='click'
                    data-kt-menu-placement='bottom-end'
                    data-kt-menu-flip='top-end'>
                    <i className='bi bi-three-dots fs-3'></i>
                  </button>
                  <Dropdown1 />
                </div> */}
              </div>
            </div>

            <div className='d-flex flex-wrap flex-stack'>
              <div className='d-flex flex-column flex-grow-1 pe-8'>
                <div className='d-flex flex-wrap'>
                  <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                    <div className='d-flex align-items-center'>
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr066.svg'
                        className='svg-icon-3 svg-icon-success me-2'
                      />
                      <div className='fs-2 fw-bolder'>{(progression ?? 0).toFixed(2)}%</div>
                    </div>

                    <div className='fw-bold fs-6 text-gray-400'>ความคืบหน้า</div>
                  </div>

                  <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                    <div className='d-flex align-items-center'>
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr065.svg'
                        className='svg-icon-3 svg-icon-danger me-2'
                      />
                      <div className='fs-2 fw-bolder'>{project?.totalWasted ?? 0}</div>
                    </div>

                    <div className='fw-bold fs-6 text-gray-400'>ตอกเสีย (เข็ม)</div>
                  </div>

                  <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                    <div className='d-flex align-items-center'>
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr066.svg'
                        className='svg-icon-3 svg-icon-success me-2'
                      />
                      <div className='fs-2 fw-bolder'>{project?.totalHammered ?? 0}</div>
                    </div>

                    <div className='fw-bold fs-6 text-gray-400'>ตอกสำเร็จ (เข็ม)</div>
                  </div>
                </div>
              </div>

              <div className='d-flex align-items-center w-200px w-sm-300px flex-column mt-3'>
                <div className='d-flex justify-content-between w-100 mt-auto mb-2'>
                  <span className='fw-bold fs-6 text-gray-400'>ความคืบหน้าทั้งโครงการ</span>
                  <span className='fw-bolder fs-6'>{(progression ?? 0).toFixed(2)}%</span>
                </div>
                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                  <div
                    className='bg-success rounded h-5px'
                    role='progressbar'
                    style={{ width: `${progression > 100 ? 100 : progression ?? 0}%` }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='d-flex overflow-auto h-55px'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap overflow-x-auto'>
            {pages.map(page => (
              <li key={page.label} className='nav-item'>
                <Link
                  className={clsx(`nav-link text-active-primary me-6`, { active: page.active })}
                  to={page.href}
                  style={{
                    whiteSpace: 'nowrap',
                  }}>
                  {page.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default ProjectDetailHeader
